import React from 'react'

import * as firebase from 'firebase'

import { connect } from 'react-redux'

import { Divider } from 'material-ui'

import AllWorkersSelector from './AllWorkersSelector'
import TeamMembersSearch from './TeamMembersSearch'
import WorkersList from './WorkersList'

class TeamMembersFilter extends React.Component {

  constructor(props) {
    super(props)
    // Component's state.
    // Each worker from props.teamWorkers is augmented with the 'selected' and 'upperList' properties.
    this.state = {
      filter: '',
      arrange: false,
      workers: []
    }
  }

  componentDidMount() {
    // Start querying and listening for changes
    firebase.database()
      .ref(this.props.selectedWorkersDbPath)
      .on('value', this.onSelectedWorkersValue)
  }

  componentWillUnmount() {
    firebase.database()
      .ref(this.props.selectedWorkersDbPath)
      .off('value', this.onSelectedWorkersValue)
  }

  onSelectedWorkersValue = (snapshot) => {
    const currentWorkers = this.state.workers.length > 0
      ? this.state.workers
      : this.props.teamWorkers
    let value = snapshot.val()
    let workersSelector = worker => ({ ...worker, selected: false })
    // The value hasn't been set or 'everyone' is true    
    if (!value || value.everyone) {
      workersSelector = worker => ({ ...worker, selected: true })
    }
    else
    if (value.list) {
      const selectedWorkersIds = Object.keys(value.list)
      workersSelector = worker => ({ ...worker,
        selected: selectedWorkersIds.find(id => worker.userId === id) !== undefined
      })
    }
    // The first time the component mounts, the list is determined by the workers selected property.
    // If upperList has a value, then use that value, as rearrangement is triggered from 
    // mouseLeave event.
    const listSelector = worker => ({ ...worker,
      upperList: worker.upperList === undefined
        ? worker.selected
        : worker.upperList
    })
    const workers = currentWorkers.map(workersSelector).map(listSelector)
    this.setState({ workers })
    // onSelectedWorkersChanged expects the list of selected workers
    this.props.onSelectedWorkersChanged(workers.filter(worker => worker.selected))
  }

  handleFilterChanged = (filter) => {
    this.setState({ filter })
  }

  handleWorkerToggled = (id) => {
    // update the toggled worker
    const updatedWorkers = this.state.workers
      .map(w => w.userId !== id ? w : ({ ...w, selected: !w.selected }))
    // handle 'everyone' property.
    const allSelected = updatedWorkers.every(w => w.selected)
    const allDeselected = updatedWorkers.every(w => !w.selected)
    let updates = {}
    if (allSelected || allDeselected) {
      updates[this.props.selectedWorkersDbPath] = { everyone: allSelected }
    }
    else {
      const list = {}
      updatedWorkers.filter(w => w.selected).forEach(w => list[w.userId] = true)
      updates[this.props.selectedWorkersDbPath] = { everyone: false, list }
    }
    firebase.database().ref().update(updates)
  }

  handleSelectAllClicked = (checked) => {
    firebase.database()
      .ref(this.props.selectedWorkersDbPath)
      .set({ everyone: checked })
  }

  handleOnMouseLeave = () => {
    const workers = this.state.workers
    // rearrange items 
    this.setState({
      arrange: true,
      workers: workers.map(w => ({ ...w, upperList: w.selected }))
    })
  }

  handleOnMouseEnter = () => {
    const workers = this.state.workers
    this.setState({
      arrange: false,
      workers: workers.map(w => ({ ...w, upperList: w.selected }))
    })
  }

  render() {
    const visibleWorkers = this.state.workers
      .filter(worker => this.state.filter === '' ||
        worker.displayName.toLowerCase().indexOf(this.state.filter.toLowerCase()) !== -1)
    return (
      <div style={teamMembersFilterStyle}
        onMouseLeave={this.handleOnMouseLeave}
        onMouseEnter={this.handleOnMouseEnter}>
        <p style={headerStyle}>Team Members</p>
        <TeamMembersSearch
          filter={this.state.filter}
          onFilterChanged={this.handleFilterChanged} />
        <AllWorkersSelector
          checked={this.state.workers.every(w => w.selected)}
          onToggleSelectAll={this.handleSelectAllClicked}/>
        <Divider
          style={{ marginTop: 4, marginBottom: 4 }} key='divider'/>
        <WorkersList
          list={visibleWorkers}
          onWorkerToggled={this.handleWorkerToggled} />
      </div>
    )
  }

}

const teamMembersFilterStyle = {
  textAlign: 'start',
  fontSize: 14
}

const headerStyle = {
  textAlign: 'center',
  color: 'RGBA(0, 0, 0, 0.4)',
  fontSize: 16,
  marginTop: 10,
  marginBottom: 8
}

function mapStateToProps(state) {
  let teamWorkers = []
  let teamId = undefined

  const teamInfo = state.firebase.team
  if (teamInfo) {
    if (teamInfo.members && !teamInfo.members.loading) {
      teamWorkers = teamInfo.members.value
    }
    if (teamInfo.metadata && !teamInfo.metadata.loading) {
      teamId = teamInfo.metadata.value.id
    }
  }

  return {
    teamId: teamId,
    teamWorkers: teamWorkers,
    selectedWorkersDbPath: `users/${state.firebase.userAuth.id}/settings/selectedWorkers/${teamId}/`
  }
}

export default connect(mapStateToProps)(TeamMembersFilter)


// WEBPACK FOOTER //
// ./src/schedule/workers/TeamMembersFilter.js